import React from "react";
import { Icon } from "@chakra-ui/react";
import { MdHome, MdDashboard, MdList, MdPerson, MdChat, MdAttachMoney, MdUpload, MdInfo, MdLibraryBooks, MdLeaderboard } from "react-icons/md";
import { useTranslation } from "react-i18next";

// Public Pages
import HomePage from "./pages/public/HomePage";
import LandingPage from "./pages/public/LandingPage";
import SignInPage from "./pages/auth/SignInPage";
import SignUpPage from "./pages/auth/SignUpPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import PersonalInfoPage from "./pages/auth/PersonalInfoPage";
import VerificationPage from "./pages/auth/VerificationPage";
import NotFoundPage from "./pages/public/NotFoundPage";
import TermsOfUsePage from "./pages/public/TermsOfUsePage";
import PrivacyPolicyPage from "./pages/public/PrivacyPolicyPage";
import AccountDeletionPage from "./pages/public/AccountDeletionPage";

// Protected Pages
import DashboardPage from "./pages/personal/DashboardPage";
import ListingPage from "./pages/personal/ListingPage";
import ProfilePage from "./pages/personal/ProfilePage";
import ChatPage from "./pages/personal/ChatPage";
import ChatListPage from "./pages/personal/ChatListPage";
import PostListingPage from "./pages/personal/PostListingPage";
import BillingPage from "./pages/personal/BillingPage";
import KYCUploadPage from "./pages/personal/KYCUploadPage";
import DocumentsInfoPage from "./pages/personal/DocumentsInfoPage";
import LeaderboardPage from "./pages/personal/LeaderboardPage";

// Miscellaneous
import TestPage from "./pages/TestPage";

export default function useTranslatedRoutes() {
  const { t } = useTranslation();

  const routes = [
    // Public Routes
    {
      name: t("routes.home"),
      path: "/",
      component: <HomePage />,
      icon: <Icon as={MdHome} />,
      layout: "public",
      protected: false,
    },
    {
      name: t("routes.landing"),
      path: "/landing",
      component: <LandingPage />,
      icon: <Icon as={MdHome} />,
      layout: "public",
      protected: false,
    },
    {
      name: t("routes.sign_in"),
      path: "/auth/sign-in",
      component: <SignInPage />,
      icon: <Icon as={MdPerson} />,
      layout: "auth",
      protected: false,
    },
    {
      name: t("routes.sign_up"),
      path: "/auth/sign-up",
      component: <SignUpPage />,
      icon: <Icon as={MdPerson} />,
      layout: "auth",
      protected: false,
    },
    {
      name: t("routes.forgot_password"),
      path: "/auth/forgot-password",
      component: <ForgotPasswordPage />,
      icon: <Icon as={MdPerson} />,
      layout: "auth",
      protected: false,
    },
    {
      name: t("routes.documents_info"),
      path: "/auth/info-details",
      component: <PersonalInfoPage />,
      icon: <Icon as={MdInfo} />,
      layout: "auth",
      protected: false,
    },
    {
      name: t("routes.verification"),
      path: "/auth/verify",
      component: <VerificationPage />,
      icon: <Icon as={MdInfo} />,
      layout: "auth",
      protected: false,
    },

    // Protected Routes
    {
      name: t("routes.dashboard"),
      path: "/personal/dashboard",
      component: <DashboardPage />,
      icon: <Icon as={MdDashboard} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.listings"),
      path: "/personal/listings",
      component: <ListingPage />,
      icon: <Icon as={MdList} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.post_listing"),
      path: "/personal/post-listing",
      component: <PostListingPage />,
      icon: <Icon as={MdList} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.profile"),
      path: "/personal/profile",
      component: <ProfilePage />,
      icon: <Icon as={MdPerson} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.chat_list"),
      path: "/personal/chat-list",
      component: <ChatListPage />,
      icon: <Icon as={MdChat} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.chat"),
      path: "/personal/chat/:chatId",
      component: <ChatPage />,
      icon: <Icon as={MdChat} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.billing"),
      path: "/personal/billing",
      component: <BillingPage />,
      icon: <Icon as={MdAttachMoney} />,
      layout: "personal",
      protected: true,
    },
    {
      name: t("routes.documents_info"),
      path: "/personal/doc-info",
      component: <DocumentsInfoPage />,
      icon: <Icon as={MdInfo} />,
      layout: "personal",
      protected: false,
    },
    {
      name: t("routes.kyc_upload"),
      path: "/personal/kyc-upload",
      component: <KYCUploadPage />,
      icon: <Icon as={MdUpload} />,
      layout: "personal",
      protected: false,
    },
    {
      name: t("routes.leaderboard"),
      path: "/personal/leaderboard",
      component: <LeaderboardPage />,
      icon: <Icon as={MdLeaderboard} />,
      layout: "personal",
      protected: true,
    },

    // Miscellaneous
    {
      name: t("routes.test_page"),
      path: "/test",
      component: <TestPage />,
      icon: <Icon as={MdLibraryBooks} />,
      layout: "misc",
      protected: false,
    },
    {
      name: t("routes.not_found"),
      path: "*",
      component: <NotFoundPage />,
      icon: null,
      layout: "public",
      protected: false,
    },
    {
      name: t("routes.terms_of_use"),
      path: "/terms-of-use",
      component: <TermsOfUsePage />,
      icon: null,
      layout: "public",
      protected: false,
    },
    {
      name: t("routes.privacy_policy"),
      path: "/privacy-policy",
      component: <PrivacyPolicyPage />,
      icon: null,
      layout: "public",
      protected: false,
    },
    {
      name: t("routes.account_deletion"),
      path: "/account-deletion",
      component: <AccountDeletionPage />,
      icon: null,
      layout: "public",
      protected: false,
    },
  ];

  return routes;
}
